import {user} from '../../api/access'
import {serv} from '@/api/config'
import LauncherAPI from '@/api/launcher'
import {RemoteAPI} from '@/api'
import {history} from '@/api/analystic'
import AppState from '@/plugins/appstate'
import Logger from '@/plugins/logger'

const execActiveX = (version, options) => {
  let args = ['AP2P']
  switch (options.command) {
    case 'RC':
      if (options.devId.indexOf('oldverion') == 0) {
        args = ['-c']
        args.push(options.kmsAddr)
        args.push(options.kmsPort)
        args.push('0')
        args.push('6')
        args.push(options.devId)
        args.push(options.n2nAddr)
        args.push(options.n2nPort)
        args.push(options.cSharpAddr)
        args.push(options.cSharpPort)
      } else {
        args.push(options.command)
        args.push(options.kmsAddr)
        args.push(options.kmsPort)
        args.push(options.devId)
        args.push(options.userId)
        args.push('TRUE')
        args.push('1')
        args.push(options.rcAuth)
        args.push(options.ftAuth)
        args.push(options.inputLock)
        args.push(options.adminAuth)
        args.push(options.userName.replace(/\s+/g, '&amp;nbsp;'))
        args.push(options.token)
        args.push(options.companyKey)
        args.push(options.n2nAddr)
        args.push(options.n2nPort)
        args.push(options.cSharpAddr)
        args.push(options.cSharpPort)
        args.push(options.deviceName.replace(/\s+/g, '&amp;nbsp;'))
        args.push(options.osType)
      }
      break
    case 'FT':
      args.push(options.command)
      args.push(options.kmsAddr)
      args.push(options.kmsPort)
      args.push(options.devId)
      args.push(options.userId)
      args.push(options.token)
      args.push(options.companyKey)
      args.push(options.n2nAddr)
      args.push(options.n2nPort)
      args.push(options.cSharpAddr)
      args.push(options.cSharpPort)
      args.push(options.deviceName.replace(/\s+/g, '&amp;nbsp;'))
      args.push(options.osType)
      break
  }

  let params;
  if (options.devId.indexOf('oldverion') == 0) {
    params = {
      body: `
      <OBJECT classid="CLSID:A5261EF0-76F0-4D9C-891C-56813163D9DA" codebase="${AppState.Path.download}/loader/KoinoLoader.cab#version=2017,4,27,0" width="271" height="14" id="KoinoLoader">
      <param name = "CompanyName" value = "LinkMeMine">
      <param name = "ApplicationName" value = "LMMViewer">
      <param name = "SectionName" value = "LMMLauncher">
      <param name = "Version" value = "${version}">
      <param name = "ExecuteFileName" value = "LMMViewer2K.exe ${args.join(' ')}">
      <param name = "HostAddress" value = "${AppState.Path.domain}">
      <param name = "HostURL" value = "download/lmmviewer/">
      </OBJECT>
      `
    }
  } else {
    params = {
      body: `
      <OBJECT classid="CLSID:A5261EF0-76F0-4D9C-891C-56813163D9DA" codebase="${AppState.Path.download}/loader/KoinoLoader.cab#version=2017,4,27,0" width="271" height="14" id="KoinoLoader">
      <param name = "CompanyName" value = "LinkMeMine">
      <param name = "ApplicationName" value = "LMMViewer">
      <param name = "SectionName" value = "LMMLauncher">
      <param name = "Version" value = "${version}">
      <param name = "ExecuteFileName" value = "LMMViewer.exe ${args.join(' ')}">
      <param name = "HostAddress" value = "${AppState.Path.domain}">
      <param name = "HostURL" value = "download/lmmviewer/">
      </OBJECT>
      `
    }
  }
  AppState.$emit('show-hidden-dialog', params)
}

const remote = (dev, noActiveX) => {
  var now = new Date()
  var pivot = new Date('2017-04-01')
  var serverNum = parseInt((now.getTime() - pivot.getTime()) / 1000)
  const {ua} = AppState
  const usr = user()

  history.post('audit', {
    act_name_id: 1,
    act_type_id: 1,
    device_pk: dev.pk,
    member_pk: usr.pk,
    new_value: 1,
    old_value: 1
  })

  if (!noActiveX && !process.env.VUE_APP_USE_ACTIVEX) noActiveX = true

  // IE고 대상 OS가 모바일이 아닐때 ActiveX 실행
  if (!noActiveX && ua.browser.name === 'IE' && dev.dev_os_id !== 4 && dev.dev_os_id !== 5) {
    LauncherAPI(dev.dev_os_id + dev.guid, (err, {session, version}) => {
      if (err) {
        Logger.error(err)
        return 'activex_error'
      }
      execActiveX(version, {
        command: 'RC',
        kmsAddr: session.kms_addr,
        kmsPort: session.kms_port,
        devId: dev.guid,
        userId: usr.mgrid,
        rcAuth: session.rc_auth,
        ftAuth: session.ft_auth,
        inputLock: session.input_lock,
        adminAuth: session.admin_auth,
        userName: session.user_name,
        token: usr.token,
        companyKey: usr.company_fk,
        n2nAddr: session.n2nserver,
        n2nPort: session.n2nport,
        cSharpAddr: session.csharp_api_addr,
        cSharpPort: session.csharp_api_port,
        deviceName: session.device_name.replace(/\s/g, '_'),
        osType: dev.dev_os_id
      })
    })
    return 'activex'
  } else if (ua.os.name === 'Windows') {
    document.title = [
      'PCCL_CONTROL',
      'RC',
      usr.token,
      dev.dev_os_id + dev.guid,
      usr.company_fk,
      dev.dev_os_id,
      serverNum,
      ''
    ].join('-')
    
    const launcherLink = document.createElement('a')
    launcherLink.href = `pccllauncher://param=PCCL_CONTROL-RC-${usr.token}-${dev.dev_os_id + dev.guid}-${usr.company_fk}-${dev.dev_os_id}-${serverNum}-`
    launcherLink.style.display = 'none'
    document.body.appendChild(launcherLink)
    launcherLink.click()
    document.body.removeChild(launcherLink)
    return 'urlscheme'
  //} else if (ua.os.name === 'Mac OS' && window.navigator.maxTouchPoints > 0 && AppState.isApplication) {
  } else if (ua.os.name === 'Mac OS' && window.navigator.maxTouchPoints > 0) {
    let connection = [
      'RC',
      dev.kms_addr,
      dev.kms_port,
      dev.pk,
      usr.token,
      usr.company_fk,
      dev.guid,
      usr.mgrid,
      dev.dev_os_id,
      ''
    ].join(':')
    try {
      window.webkit.messageHandlers.observe.postMessage(connection)
    } catch (err) {
      Logger.error(err)
      return 'error'
    }
    return 'application'
  } else if (ua.os.name === 'Mac OS') {
    let w = 480, h = 180
    var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : window.screenX;
    var dualScreenTop = window.screenTop != undefined ? window.screenTop : window.screenY;

    var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

    var systemZoom = width / window.screen.availWidth;
    var left = (width - w) / 2 / systemZoom + dualScreenLeft
    var top = (height - h) / 2 / systemZoom + dualScreenTop

    let params =
      '?device_pk=' + dev.pk +
      '&token=' + usr.token +
      '&company_fk=' + usr.company_fk +
      '&device_guid=' + dev.guid +
      '&mgr_id=' + usr.mgrid +
      '&os_id=' + dev.dev_os_id +
      '&device_id=' + dev.alias +
      '&user_name=' + usr.name +
      '&kms_addr=' + dev.kms_addr +
      '&kms_port=' + dev.kms_port

    let b64 = btoa(encodeURIComponent(`LinkMeMineViewer://${params}`))
    let nw = window.open(`/static/mac_launcher.html?d=${b64}`, 'maclauncher', `width=${w / systemZoom},height=${h / systemZoom},top=${top},left=${left}`)
    if (window.focus) nw.focus()
    return 'urlscheme'
  } else if (ua.os.name === 'iOS' && AppState.isApplication) {
    let connection = [
      'RC',
      dev.kms_addr,
      dev.kms_port,
      dev.pk,
      usr.token,
      usr.company_fk,
      dev.guid,
      usr.mgrid,
      dev.dev_os_id,
      ''
    ].join(':')
    try {
      window.webkit.messageHandlers.observe.postMessage(connection)
    } catch (err) {
      Logger.error(err)
      return 'error'
    }
    return 'application'
  // } else if (ua.os.name === 'Android' && AppState.isApplication) {
  } else if (/Android/i.test(window.navigator.userAgent) && AppState.isApplication) {
    let connection = [
      'RC',
      dev.kms_addr,
      dev.kms_port,
      dev.pk,
      usr.token,
      usr.company_fk,
      dev.guid,
      // 안드로이드 파라미터 갯수 문제로 #으로 분기
      usr.mgrid + '#' + dev.dev_os_id,
      usr.name,
      ''
    ].join(':')
    try {
      window.AndroidViewerApp.setMessage(connection)
    } catch (err) {
      Logger.error(err)
      return 'error'
    }
    return 'application'
  } else return false
}

const transfer = dev => {
  var now = new Date()
  var pivot = new Date('2017-04-01')
  var serverNum = parseInt((now.getTime() - pivot.getTime()) / 1000)
  const {ua} = AppState
  const usr = user()

  history.post('audit', {
    act_name_id: 2,
    act_type_id: 1,
    device_pk: dev.pk,
    member_pk: usr.pk,
    new_value: 1,
    old_value: 1
  })

  if (ua.browser.name === 'IE') {
    LauncherAPI(dev.dev_os_id + dev.guid, (err, {session, version}) => {
      if (err) {
        Logger.error(err)
        return 'activex_error'
      }
      execActiveX(version, {
        command: 'FT',
        kmsAddr: session.kms_addr,
        kmsPort: session.kms_port,
        devId: dev.guid,
        userId: usr.mgrid,
        token: usr.token,
        companyKey: usr.company_fk,
        n2nAddr: session.n2nserver,
        n2nPort: session.n2nport,
        cSharpAddr: session.csharp_api_addr,
        cSharpPort: session.csharp_api_port,
        deviceName: session.device_name.replace(/\s/g, '_'),
        osType: dev.dev_os_id
      })
    })
    return 'activex'
  } else if (ua.os.name === 'Windows') {
    document.title = [
      'PCCL_CONTROL',
      'FT',
      usr.token,
      dev.dev_os_id + dev.guid,
      usr.company_fk,
      dev.dev_os_id,
      serverNum,
      ''
    ].join(':')
    window.open(`${serv.download}/PCCLLauncher.exe?cache=210621_02`, '_blank')
    return 'download'
  } else if (ua.os.name === 'Mac OS') {
    return false
  } else if (ua.os.name === 'iOS' && AppState.isApplication) {
    return false
  } else if (ua.os.name === 'Android' && AppState.isApplication) {
    return false
  } else return false
}

// AuditHistory.save(argument, function(data){
//     if(data.status==200){
//         $scope.audit_result = data.objects;
//     }
// });

const shutdown = dev => {
  const usr = user()
  var params = {
    device_pk: dev.pk,
    member_pk: usr.pk,
    act_name_id: 4,
    act_type_id: 1,
    old_value: 1,
    new_value: 1,
    // 실행시 추가 audit에는 제외
    type: 'shutdown'
  }

  history.post('audit', {
    act_name_id: 4,
    act_type_id: 1,
    device_pk: dev.pk,
    member_pk: usr.pk,
    new_value: 1,
    old_value: 1
  })

  RemoteAPI.put(dev.guid, params)
  return 'requested'
}

const reboot = dev => {
  const usr = user()
  var params = {
    device_pk: dev.pk,
    member_pk: usr.pk,
    act_name_id: 3,
    act_type_id: 1,
    old_value: 1,
    new_value: 1,
    // 실행시 추가 audit에는 제외
    type: 'reboot'
  }

  history.post('audit', {
    act_name_id: 3,
    act_type_id: 1,
    device_pk: dev.pk,
    member_pk: usr.pk,
    new_value: 1,
    old_value: 1
  })

  RemoteAPI.put(dev.guid, params)
  return 'requested'
}

const restart = dev => {
  // const usr = user()
  var params = {
    // device_pk: dev.pk,
    // member_pk: usr.pk,
    // act_name_id: 3,
    // act_type_id: 1,
    // old_value: 1,
    // new_value: 1,
    // 실행시 추가 audit에는 제외
    type: 'agent_restart'
  }

  // 에이전트 재시작에 대한 아이디 필요
  // history.post('audit', {
  //   act_name_id: 3,
  //   act_type_id: 1,
  //   device_pk: dev.pk,
  //   member_pk: usr.pk,
  //   new_value: 1,
  //   old_value: 1
  // })

  RemoteAPI.put(dev.guid, params)
  return 'requested'
}

const information = dev => {
  let params = {
    type: 'information',
  }
  if (Array.isArray(dev)) {
    dev.forEach(item => {
      RemoteAPI.put(item, params);
    })
  } else {
    RemoteAPI.put(dev, params)
  }
  return 'requested'
}

const remove = dev => {
  var params = {
    type: 'delete'
  }

  return RemoteAPI.put(dev.guid, params)
}

export default { remote, transfer, reboot, shutdown, restart, remove, information }